import { render, staticRenderFns } from "./ClientDetailsPage.vue?vue&type=template&id=f2ab98ec&scoped=true"
import script from "./ClientDetailsPage.vue?vue&type=script&lang=js"
export * from "./ClientDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ClientDetailsPage.vue?vue&type=style&index=0&id=f2ab98ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ab98ec",
  null
  
)

export default component.exports